
document.addEventListener("DOMContentLoaded", function () {
  const topWrap = document.querySelector(".top__wrap");
  const headerWrap = document.querySelector(".header__wrap");

  document.getElementById("about").addEventListener("click", function () {
    topWrap.classList.remove("search-open");
    topWrap.classList.toggle("about-open");
  });

  document.getElementById("open-about").addEventListener("click", function () {
    topWrap.classList.remove("search-open");
    topWrap.classList.toggle("about-open");
  });

  document.getElementById("search").addEventListener("click", function () {
    topWrap.classList.remove("about-open");
    topWrap.classList.toggle("search-open");
  });

  document.getElementById("mobile-hbg").addEventListener("click", function () {
    headerWrap.classList.toggle("open");
  });
});


